import React from "react";
import { Link } from "react-router-dom";
import {
  ManageAccountsOutlined,
  LanguageOutlined,
  InfoOutlined,
  CampaignOutlined,
  ArticleOutlined,
  EmailOutlined,
  FlagOutlined,
  LockOutlined,
  SupervisedUserCircleOutlined,
  GroupsOutlined,
  AlternateEmailOutlined,
  GroupOutlined,
  AddTask,
  ConfirmationNumberOutlined,
  FeedbackOutlined,
  StorefrontOutlined,
  LocalShippingOutlined,
  AssignmentOutlined,
  PeopleAltOutlined,
  DriveEta,
  DriveEtaOutlined,
  AccountBalanceOutlined,
  TipsAndUpdatesOutlined,
  IntegrationInstructionsOutlined,
  FeedOutlined,
  MyLocationOutlined,
  PublicOutlined,
  LocationCity,
  ApartmentOutlined,
  ReorderOutlined,
  DockOutlined,
  WarehouseOutlined,
  NfcOutlined,
} from "@mui/icons-material";
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  Box,
} from "@mui/material";
import { useAuth } from "hooks";

// Function to dynamically map icon names to MUI icon components
const getIcon = (iconName) => {
  const iconStyle = { color: "primary.main", fontSize: 25 };
  const icons = {
    ManageAccountsOutlined: <ManageAccountsOutlined sx={iconStyle} />,
    LanguageOutlined: <LanguageOutlined sx={iconStyle} />,
    InfoOutlined: <InfoOutlined sx={iconStyle} />,
    CampaignOutlined: <CampaignOutlined sx={iconStyle} />,
    ArticleOutlined: <ArticleOutlined sx={iconStyle} />,
    FlagOutlined: <FlagOutlined sx={iconStyle} />,
    LockOutlined: <LockOutlined sx={iconStyle} />,
    SupervisedUserCircleOutlined: (
      <SupervisedUserCircleOutlined sx={iconStyle} />
    ),
    GroupsOutlined: <GroupsOutlined sx={iconStyle} />,
    AlternateEmailOutlined: <AlternateEmailOutlined sx={iconStyle} />,
    GroupOutlined: <GroupOutlined sx={iconStyle} />,
    EmailOutlined: <EmailOutlined sx={iconStyle} />,
    AddTask: <AddTask sx={iconStyle} />,
    ConfirmationNumberOutlined: <ConfirmationNumberOutlined sx={iconStyle} />,
    FeedbackOutlined: <FeedbackOutlined sx={iconStyle} />,
    StorefrontOutlined: <StorefrontOutlined sx={iconStyle} />,
    LocalShippingOutlined: <LocalShippingOutlined sx={iconStyle} />,
    AssignmentOutlined: <AssignmentOutlined sx={iconStyle} />,
    PeopleAltOutlined: <PeopleAltOutlined sx={iconStyle} />,
    DriveEta: <DriveEta sx={iconStyle} />,
    DriveEtaOutlined: <DriveEtaOutlined sx={iconStyle} />,
    AccountBalanceOutlined: <AccountBalanceOutlined sx={iconStyle} />,
    TipsAndUpdatesOutlined: <TipsAndUpdatesOutlined sx={iconStyle} />,
    IntegrationInstructionsOutlined: (
      <IntegrationInstructionsOutlined sx={iconStyle} />
    ),
    FeedOutlined: <FeedOutlined sx={iconStyle} />,
    MyLocationOutlined: <MyLocationOutlined sx={iconStyle} />,
    PublicOutlined: <PublicOutlined sx={iconStyle} />,
    LocationCity: <LocationCity sx={iconStyle} />,
    ApartmentOutlined: <ApartmentOutlined sx={iconStyle} />,
    ReorderOutlined: <ReorderOutlined sx={iconStyle} />,
    DockOutlined: <DockOutlined sx={iconStyle} />,
    WarehouseOutlined: <WarehouseOutlined sx={iconStyle} />,
    NfcOutlined: <NfcOutlined sx={iconStyle} />,
  };
  return icons[iconName] || null;
};

const SettingListScreen = () => {
  const { isSystemAdmin } = useAuth();

  const menuSections = [
    {
      title: "Setup",
      items: [
        {
          title: "Global List",
          path: "/app/crm/global-list",
          icon: "LanguageOutlined",
        },

        {
          title: "Account List",
          path: "/app/crm/account-list",
          icon: "ManageAccountsOutlined",
        },
        {
          title: "Entity List",
          path: "/app/crm/entity-list",
          icon: "ReorderOutlined",
        },
        {
          title: "Users",
          path: "/app/crm/user/list",
          icon: "SupervisedUserCircleOutlined",
        },

        {
          title: "Authorizations",
          path: "/app/crm/authorization/list/account",
          icon: "LockOutlined",
        },

        {
          title: "Accounts",
          path: "/app/crm/account/list",
          icon: "GroupOutlined",
        },
        {
          title: "Entities",
          path: "/app/crm/entity/list",
          icon: "InfoOutlined",
        },
      ],
    },
    {
      title: "Organization",
      items: [
        { title: "Blogs", path: "/app/crm/blog/list", icon: "ArticleOutlined" },
        {
          title: "Account Info",
          path: "/app/crm/account/info",
          icon: "GroupOutlined",
        },
        {
          title: "Email Templates",
          path: "/app/crm/email-template/list",
          icon: "AlternateEmailOutlined",
        },

        {
          title: "Countries",
          path: "/app/crm/country/list",
          icon: "FlagOutlined",
        },

        {
          title: "Region",
          path: "/app/crm/region/list",
          icon: "PublicOutlined",
        },
        {
          title: "District",
          path: "/app/crm/district/list",
          icon: "LocationCity",
        },
        {
          title: "Municipality",
          path: "/app/crm/municipality/list",
          icon: "ApartmentOutlined",
        },
      ],
    },
    {
      title: "Driver",
      items: [
        {
          title: "Driver",
          path: "/app/crm/driver/list",
          icon: "ManageAccountsOutlined",
        },
        {
          title: "Driver Licence",
          path: "/app/crm/driver/driverLicence",
          icon: "ManageAccountsOutlined",
        },
        {
          title: "Cross-Docking",
          path: "/app/crm/cross-docking/list",
          icon: "DockOutlined",
        },
        {
          title: "Transshipment",
          path: "/app/crm/transshipment/list",
          icon: "PeopleAltOutlined",
        },
        { title: "Vehicle", path: "/app/crm/vehicle/list", icon: "DriveEta" },
        {
          title: "Vehicle Maintenance",
          path: "/app/crm/vehicle-maintenance/list",
          icon: "DriveEtaOutlined",
        },
        {
          title: "Insurances",
          path: "/app/crm/vehicle/vehicleInsurance",
          icon: "AccountBalanceOutlined",
        },
      ],
    },
    {
      title: "Shipment",
      items: [
        {
          title: "Shipment",
          path: "/app/crm/shipment/list",
          icon: "LocalShippingOutlined",
        },
        {
          title: "Shipment Document",
          path: "/app/crm/collection-document/list",
          icon: "AssignmentOutlined",
        },
        {
          title: "Collection",
          path: "/app/crm/collection/list",
          icon: "LocalShippingOutlined",
        },
        {
          title: "Shipment Completion",
          path: "/app/crm/shipment-completion/list",
          icon: "LocalShippingOutlined",
        },
      ],
    },
    {
      title: "Warehouse",
      items: [
        {
          title: "Warehouse",
          path: "/app/crm/warehouse/list",
          icon: "WarehouseOutlined",
        },
        { title: "Branch", path: "/app/crm/branch/list", icon: "LocationCity" },
        {
          title: "Warehouse Allocation",
          path: "/app/crm/warehouse-allocation/list",
          icon: "WarehouseOutlined",
        },
        {
          title: "Compliance",
          path: "/app/crm/compliance/list",
          icon: "TipsAndUpdatesOutlined",
        },
        {
          title: "Data Integration",
          path: "/app/crm/dataIntegration/list",
          icon: "IntegrationInstructionsOutlined",
        },
        {
          title: "Incident Report",
          path: "/app/crm/incident-report/list",
          icon: "FeedOutlined",
        },
        {
          title: "Real Time Tracking",
          path: "/app/crm/realtime-tracking/list",
          icon: "MyLocationOutlined",
        },
      ],
    },
    {
      title: "Customer Focused",
      items: [
        {
          title: "Customer",
          path: "/app/crm/customerUser/list",
          icon: "PeopleAltOutlined",
        },
        {
          title: "Communication",
          path: "/app/crm/communication/list",
          icon: "NfcOutlined",
        },
        {
          title: "Contractor",
          path: "/app/crm/contractor/list",
          icon: "ManageAccountsOutlined",
        },
      ],
    },
    ...(isSystemAdmin
      ? [
        {
          title: "SMS",
          items: [
            {
              title: "SMS Provider",
              path: "/app/crm/sms-provider/list",
              icon: "PeopleAltOutlined",
            },
            {
              title: "SMS Template",
              path: "/app/crm/sms-templates/list",
              icon: "EmailOutlined",
            },
            {
              title: "SMS Integrations",
              path: "/app/crm/sms-integrations/list",
              icon: "IntegrationInstructionsOutlined",
            },
          ],
        },
      ]
      : []),
    ...(isSystemAdmin
      ? [
        {
          title: "Payment Integration Provider",
          items: [
            {
              title: "Payment Integration Provider",
              path: "/app/crm/paymentIntegration/list",
              icon: "PeopleAltOutlined",
            },
          ],
        },
      ]
      : []),
    ...(isSystemAdmin
      ? [
        {
          title: "E-Bill Provider",
          items: [
            {
              title: "E-Bill Provider",
              path: "/app/crm/ebill-provider/list",
              icon: "AccountBalanceOutlined",
            },
          ],
        },
      ]
      : []),
  ];

  return (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Grid container spacing={3}>
        {menuSections.map((section, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Paper elevation={3} sx={{ p: 1, height: "100%" }}>
              <Typography
                variant="h6"
                gutterBottom
                sx={{ fontWeight: "bold", color: "primary.main" }}
              >
                {section.title}
              </Typography>
              <TableContainer>
                <Table>
                  <TableBody>
                    {section.items.map((item, idx) => (
                      <TableRow
                        key={idx}
                        hover
                        sx={{ "&:hover": { backgroundColor: "action.hover" } }}
                      >
                        <TableCell sx={{ padding: "4px" }}>
                          {getIcon(item.icon)}
                        </TableCell>
                        <TableCell sx={{ padding: "4px" }}>
                          <Link
                            to={item.path}
                            style={{
                              textDecoration: "none",
                              color: "inherit",
                              fontSize: "14px",
                            }}
                          >
                            {item.title}
                          </Link>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default SettingListScreen;
